import { lazy } from 'react'

const isChunkError = (message: string) => {
  const lowerMessage = message?.toLowerCase() || ''
  return lowerMessage.includes('loading chunk') ||
    lowerMessage.includes('failed to fetch dynamically imported module') ||
    lowerMessage.includes('failed to load module script') ||
    lowerMessage.includes('expected a javascript-or-wasm module script')
}

/**
 * Enhanced lazy loading that automatically reloads the page when chunk loading fails.
 * This handles the common issue where users get chunk errors after deployments.
 */
export const lazyWithChunkErrorHandling = (importFn: () => Promise<any>) => {
  return lazy(() =>
    importFn().catch(error => {
      if (isChunkError(error.message)) {
        window.location.reload()
      }
      throw error
    })
  )
}
